import React from 'react';
import PropTypes from 'prop-types';

import config from '../../../config';

function AppLogo(props) {
    return (
        <img src={`${config.url}assets/images/logo${props.suffix ? `-${props.suffix}` : ''}.png`} alt={config.application.name} {...props} />
    );
}

AppLogo.defaultProps = {
    suffix: '',
};

AppLogo.propTypes = {
    suffix: PropTypes.string,
};

export default AppLogo;
